import React from 'react'
import PropTypes from 'prop-types'
import { Field, FieldArray } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'

import PostcodeRuleInput from './PostcodeRuleInput'

const PostcodeRules = ({ name }) => (
    <Field name={name}>
        {({ field }) => (
            <FieldArray name={field.name}>
                {({ push, remove }) => (
                    <>
                        {field?.value?.length > 0 && (
                            <table className="table table-sm">
                                <colgroup>
                                    <col width="30%" />
                                    <col width="30%" />
                                    <col width="30%" />
                                    <col width="10%" />
                                </colgroup>

                                <thead>
                                    <tr>
                                        <th>Outcode</th>
                                        <th>District Start</th>
                                        <th>District End</th>
                                        <th className="!text-right">Remove</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {field.value.map((item, index) => (
                                        <tr key={`postcodeRules-uk-${index}`}>
                                            <td>{item.postcodeArea}</td>
                                            <td>
                                                {item.districtStart !== null
                                                    ? item.districtStart
                                                    : '-'}
                                            </td>

                                            <td>
                                                {item.districtEnd !== null ? item.districtEnd : '-'}
                                            </td>
                                            <td className="!text-right">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => {
                                                        remove(index)
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}

                        <div className="form-group">
                            <label className="!mb-1">Add Postcode Rule</label>
                            <PostcodeRuleInput push={push} />
                        </div>
                    </>
                )}
            </FieldArray>
        )}
    </Field>
)

PostcodeRules.propTypes = {
    name: PropTypes.string.isRequired,
    includeCost: PropTypes.bool,
}

export default PostcodeRules
